import { Injectable } from "@angular/core";
import { HttpEvent, HttpInterceptor, HttpHandler,HttpRequest, HttpErrorResponse } from "@angular/common/http";
import { throwError, Observable, BehaviorSubject, of } from "rxjs";
import { catchError, filter, take, switchMap } from "rxjs/operators";
import { Router, NavigationStart } from '@angular/router';


import { AuthenticationService } from '../_services';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

    private AUTH_HEADER = "authorizatio";
  private token = "secrettoken";
  private refreshTokenInProgress = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);


    constructor(private authenticationService: AuthenticationService, private router: Router,
      ) {}

    private handleAuthError(err: HttpErrorResponse): Observable<any> {
        //handle your auth error or rethrow
        if (err.status === 401 || err.status === 403) {
            //navigate /delete cookies or whatever
       
            this.authenticationService.logout();
            //     this.router.navigateByUrl(`/login`);
            // if you've caught / handled the error, you don't want to rethrow it unless you also want downstream consumers to have to handle it as well.
            return of(err.message); // or EMPTY may be appropriate here
        }
        return throwError(err);
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
       

        if (!req.headers.has('Content-Type')) {
            req = req.clone({
              headers: req.headers.set('Content-Type', 'application/json')
            });


          }
       
         req = this.addAuthenticationToken(req);
       
        return next.handle(req); 

    } 



    private addAuthenticationToken(request: HttpRequest<any>): HttpRequest<any> {
       
        let currentUser = this.authenticationService.currentUserValue;

        if (!currentUser) {
          return request;
        }
       

        if (currentUser && currentUser.accessToken) {


        return request.clone({
          headers: request.headers.set(this.AUTH_HEADER, "Bearer " + currentUser.accessToken)
        });
    }
      }
}